<template>
    <card class="mb-4">
        <card-header>Trending Over time</card-header>
        <card-body class="pt-0" v-if="loading">
            <card-spinner size="large" style="height: 240px;"/>
        </card-body>
        <card-body class="p-3" v-if="!loading" style="max-height: 300px;">
            <bar-chart :chart-data="chartData" :options="options" :width="210" :height="230"/>
        </card-body>
    </card>
</template>

<script>
    import {BarChart} from "./../shared/charts";
    import {mapState} from 'vuex';

    export default {
        components: {BarChart},

        props: {
            type      : {default: 'public'},
            maxOverall: {default: 5},
        },

        data: () => ({
            trending_over_time: [],
            loading           : false,
        }),

        watch: {
            filter() {
                this.fetchTrendingOverTimeData();
            }
        },

        async created() {
            this.loading = true;
            await this.fetchTrendingOverTimeData();
            this.loading = false;
        },

        computed: {
            ...mapState(['filter']),
            months() {
                return this.trending_over_time.map(t => t.interval);
            },
            reviews() {
                return this.trending_over_time.map(t => t.reviews);
            },
            averages() {
                return this.trending_over_time.map(t => t.average);
            },
            chartData() {
                return {
                    labels  : this.months,
                    datasets: [
                        {
                            type           : "bar",
                            yAxisID        : 'quantity',
                            label          : "Reviews",
                            data           : this.reviews,
                            backgroundColor: "rgba(2, 91, 175, .9)",
                        },
                        {
                            type                : "line",
                            yAxisID             : 'average',
                            label               : "Overall Score",
                            data                : this.averages,
                            backgroundColor     : "rgba(230, 230, 230, .8)",
                            borderWidth         : 1,
                            pointBackgroundColor: '#ababab',
                        }
                    ],
                }
            },
            options() {
                return {
                    resposinve         : true,
                    maintainAspectRatio: false,
                    scales             : {
                        yAxes: [
                            {
                                id      : 'quantity',
                                position: 'left',
                                type    : 'linear',
                                ticks   : {
                                    beginAtZero        : true,
                                    responsive         : false,
                                    maintainAspectRatio: true
                                }
                            },
                            {
                                id      : 'average',
                                position: 'right',
                                type    : 'linear',
                                ticks   : {
                                    beginAtZero        : true,
                                    max                : this.maxOverall,
                                    responsive         : false,
                                    maintainAspectRatio: true
                                },
                            }
                        ],
                        xAxes: [{
                            barPercentage: 0.5
                        }],
                    },
                    legend             : {
                        labels: {
                            fontColor: '#8c8c8c',
                            fontSize : 13,
                            boxWidth : 15
                        }
                    },
                    tooltips           : {
                        mode: 'index'
                    }
                }
            },
        },

        methods: {
            fetchTrendingOverTimeData() {
                const params = {...this.filter, type: this.type, interval: 'yearly'};
                return this.$http.get(this.$laroute.route('api.reviews.trending-over-time'), {params})
                    .then(({data}) => this.trending_over_time = data);
            },
        }
    };
</script>

<style lang="scss" scoped>
    .gray {
        color: #afafaf
    }
</style>
